import { useDispatch, useSelector } from "react-redux"
import Popup from "../../../../components/Popup"
import { closeSendToAkadPopup, selectSendToAkadPopupData, sendShipmentToAkad, setShipmentToSendToAkadPending } from "../../shipmentsSlice"
import { Button } from "@mui/material"
import { useTranslation } from "react-i18next"
import { COURIER_DELIVERY_TYPE, LOCAL_CARGO_DELIVERY_TYPE, VISIT_OFFICE_DELIVERY_TYPE } from "../../../../data/static-data"

const SendToAkadPopup = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch()
    const sendToAkadPopupData = useSelector(selectSendToAkadPopupData)
    const shipment = useSelector(state => state.shipments.shipments.find(shipment => shipment.id === sendToAkadPopupData.shipmentID))
    // const shipment = {"getting-package-type": COURIER_DELIVERY_TYPE}
    const closePopup = () => {
        dispatch(closeSendToAkadPopup())
    }

    const handleSendToAkadButtonClick = () => {
        if (!sendToAkadPopupData.shipmentID) {
            return
        }

        dispatch(setShipmentToSendToAkadPending({ shipmentID: sendToAkadPopupData.shipmentID }))
        dispatch(sendShipmentToAkad({
            shipmentID: sendToAkadPopupData.shipmentID,
        }))
        closePopup()
    }   



    return (
    <Popup opened={sendToAkadPopupData.opened} closeCallback={closePopup}>
        {
            shipment &&
            <div className="mr-12 flex flex-col gap-8 text-2xs text-left">
                <span> 
                    <p className="text-red-600"> 
                        {t("shipments.send_to_akad_popup.warning")}
                    </p>
                    
                    <br />
                    <p> 
                        {
                            shipment["getting-package-type"] === COURIER_DELIVERY_TYPE &&
                            <>
                                <div>{t("send_to_akad.getting_package_types.courier.title")}:</div>
                                <div 
                                    className="ml-6"
                                >
                                    {t("send_to_akad.getting_package_types.courier.description")}
                                </div>
                            </>
                        }
                        {
                            shipment["getting-package-type"] === VISIT_OFFICE_DELIVERY_TYPE &&
                            <>
                                <div>{t("send_to_akad.getting_package_types.visit_office.title")}:</div>
                                <div 
                                    className="ml-6"
                                >
                                    {t("send_to_akad.getting_package_types.visit_office.description")}
                                </div>
                            </>
                        }
                        {
                            shipment["getting-package-type"] === LOCAL_CARGO_DELIVERY_TYPE &&
                            <>
                                <div>{t("send_to_akad.getting_package_types.local_cargo.title")}:</div>
                                <div 
                                    className="ml-6"
                                >
                                    {t("send_to_akad.getting_package_types.local_cargo.description")}
                                </div>
                            </>
                        }
                    </p>

                    <br />
                    <p className="text-red-600"> 
                        {t("shipments.send_to_akad_popup.confirm_sentence")} {sendToAkadPopupData.shipmentID}?
                    </p>
                </span>
                <Button
                        variant="contained"
                        sx={{
                            color: "white",
                            bgcolor: "#059669",
                            fontSize: "0.7rem",
                            ":hover": {
                                bgcolor: "#047857",
                            },
                        }}
                        onClick={handleSendToAkadButtonClick}
                    >
                        {
                            shipment["getting-package-type"] === COURIER_DELIVERY_TYPE ?
                            t("shipments.send_to_akad_popup.call_courier_button") :
                            t("shipments.send_to_akad_popup.send_button")
                        }
                </Button>

            </div>
        }
    </Popup>
  )
}

export default SendToAkadPopup